/**
 * PRIMARY KEY import validation stub. Kept so existing imports compile without changes.
 */
export function getDictionaryDefinitionImportPkErrors(
  _rows: Record<string, string>[],
  _options: {
    importIsAppend: boolean;
    existingFields: readonly { fieldName: string }[];
  },
): string[] {
  return [];
}
